import { FC, useState, MouseEvent, useEffect } from 'react'

import './style.scss'
import { Card, Icon, Loading, Paginate, Table, Text, Tooltip } from '../../UI'
import { FamilyGroupFilter } from '..'

type MedicalAppointmentsUpcomingsProps = {
  data: any,
  familyFilter: any,
  familyFilterSelected: string,
  onDataReload?(patientId: string): void
}

const pageDefault: number = 1
const pageSizeDefault: number = 5

const TableLabel:FC = ({ children }) => <Text component="label" color="primary" size="14">{children}</Text>

const TableText:FC = ({ children }) => <Text component="span" size="14">{children}</Text>

const ToolTipText = () => <Text size="12">Haciendo clic en el icono podrás volver a reservar una hora médica con el mismo profesional.</Text>

const MedicalAppointments:FC<MedicalAppointmentsUpcomingsProps> = ({ data, familyFilter, familyFilterSelected, onDataReload }) => {
  const [pageCurrent, setPageCurrent] = useState<number>(pageDefault)
  const [tableItemsShow, setTableItemsShow] = useState<boolean[]>([false, false, false, false, false, false, false, false, false, false])
  const [dataPage, setDataPage] = useState<any[] | null>(null)

  useEffect(() => {
    getDataPageCurrent(pageDefault)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const tableColumns = [
    {
      accessor: 'doctor_name',
      Header: 'Profesional',
      width: '30%',
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <>
            <span className="d-block">{original.doctor_name}</span>
            <span className="d-block fz-12 mt-5">{original.specialty} - {original.sub_context}</span>
          </>
        )
      }
    },
    {
      accessor: 'date',
      Header: 'Fecha',
      width: '15%'
    },
    {
      accessor: 'hour',
      Header: 'Hora',
      width: '12%'
    },
    {
      accessor: 'place_care',
      Header: 'Sucursal',
      width: '25%',
      Cell: (params: any) => {
        const { original} = params.row
        return (
          <>
            <span className="d-block">{original.place_care_indisa} {original.place_care}</span>
          </>
        )
      }
    },
    {
      accessor: 'action',
      Header: 'Reserva de hora',
      width: '18%',
      tooltip: <ToolTipText />,
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <div className="text-center">
            <a href="# " onClick={(event) => onAppointmentReserve(event, original)}>
              <Icon name="reserve" />
            </a>
          </div>
        )
      }
    }
  ]

  const appointmentShow = (doctorArea: string, doctorRut: string) => {
    (window as any).show_chat(doctorArea, doctorRut)
  }

  const getDataPageCurrent = (pageCurrent: number) => {
    const rowEnd: number = (pageCurrent * pageSizeDefault) - 1
    const rowIni: number = (rowEnd - pageSizeDefault) + 1

    setDataPage(
      data && data.appointments && data.appointments.length ?
        data.appointments.filter((it: any, i: number) => {
          return i >= rowIni  && i <= rowEnd
        })
      :
        data === '' ? '' : []
    )
  }

  const onPageCurrent = (pageCurrent: number) => {
    setPageCurrent(pageCurrent)
    getDataPageCurrent(pageCurrent)
  }

  const onAppointmentReserve = (event: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>, doctor: any) => {
    event.preventDefault()
    appointmentShow(doctor.cod_specialty, doctor.rut_professional)
  }

  const onTableMoreShow = (index: number) => {
    setTableItemsShow(prevState => prevState.map((item, idx) => idx === index ? !item : item))
  }

  const onFilterChange = (id: string) => {
    setPageCurrent(pageDefault)
    if(onDataReload) onDataReload(id)
  }

  return (
    <div className="map-content-mh py-25 lg:px-50">
      <FamilyGroupFilter
        data={familyFilter.data}
        dataSelected={familyFilterSelected}
        onChange={onFilterChange}
      />

      {dataPage ?
          <>
            {dataPage.length ?
                <div className="mt-20">
                  <div className="d-none lg:d-block">
                    <Table
                      columns={tableColumns}
                      data={dataPage}
                    />
                  </div>

                  <div className="d-block lg:d-none">
                    {dataPage.map((it: any, i: number) =>
                      <Card key={i} className={`py-20 px-25 ${i > 0 ? 'mt-20' : ''}`}>
                        <div>
                          <TableLabel>Profesional</TableLabel>
                          <Text component="span" size="14" weight="bold">{it.doctor_name}</Text>
                          <TableText>{it.specialty} - {it.sub_context}</TableText>
                        </div>

                        <div className="mt-10">
                          <TableLabel>Fecha</TableLabel>
                          <TableText>{it.date}</TableText>
                        </div>

                        {tableItemsShow[i] &&
                          <>
                            <div className="mt-10">
                              <TableLabel>Hora</TableLabel>
                              <TableText>{it.hour}</TableText>
                            </div>

                            <div className="mt-10">
                              <TableLabel>Sucursal</TableLabel>
                              <TableText>{it.place_care_indisa} {it.place_care}</TableText>
                            </div>

                            <div className="d-flex align-items-center mt-20">
                              <Text component="label" size="12" color="primary" inline className="align-middle mr-10">Reserva de horas</Text>
                              <Tooltip color="primary" width="160px">
                                <ToolTipText />
                              </Tooltip>

                              <a href="# " className="ml-20" onClick={(event) => onAppointmentReserve(event, it)}>
                                <Icon name="reserve" />
                              </a>
                            </div>
                          </>
                        }

                        {!tableItemsShow[i] &&
                          <div className="text-center mt-25" onClick={() => onTableMoreShow(i)}>
                            <div className="d-inline px-10">
                              <Icon name="arrow-down" />
                            </div>
                          </div>
                        }
                      </Card>
                    )}
                  </div>

                  <div className="text-center mt-20">
                    <Paginate
                      current={pageCurrent}
                      total={data.count_appointment}
                      size={pageSizeDefault}
                      onPageChange={(current) => onPageCurrent(current)}
                    />
                  </div>
                </div>
              :
                <div className="map-content_empty">
                  <Text size="14" weight="semibold" className="lg:fz-20">Aún no tienes horas médicas pasadas en este historial</Text>
                </div>
            }
          </>
        :
          <Loading size="md" align="center" className="pt-70 lg:pt-100" />
      }
    </div>
  )
}

export { MedicalAppointments }